import React, { Fragment } from "react";
import styled from "styled-components";
import { connect } from "formik";
import numeral from "numeral";
import { isEmpty, get } from "lodash";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { FormikInputTypeAhead, LOAN_RATE_TYPES, FormikInputPercent, FormikInputNumber, FormikInputMoney, DEAL_STATUSES, FormikInputText } from "@loanbossinc/component-library";

import { shouldShowInterestRate, shouldShowLoanSpread, getFixedFloating } from "../../quoteDetail.util";

const Divider = styled.div`&& {    
    border: 1px solid #DADCE0;
    width: 100%;
    height: 0px;
    margin-top:30px;
}`;

const StyledGridContainer = styled(Grid)`&&{
    margin-top: 26px
}`;
const StyledFormikInputNumber = styled(FormikInputNumber)`&&&&{
    width: 100%
}`;
const StyledFormikInputPercent = styled(FormikInputPercent)`&&&&{
    width: 100%
}`;
const StyledFormikInputText = styled(FormikInputText)`&&&&{
    width: 100%
}`;
const StyledFormikInputTypeAhead = styled(FormikInputTypeAhead)`
    border-bottom: 1px solid #2196F3;
    width: 100%;
`;
const StyledFormikInputMoney = styled(FormikInputMoney)`&&&&{
    width: 100%
}`;
const StyledHeaderContainer = styled(Grid)`&&{
    
}`;
const StyledHeader = styled.span`&&{
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;

    color: #000000;
}`;

const FinancialsSection = ({ formik }) => {
  const { values } = formik;
  const rateTypeId = get(values, "details.rateTypeId");
  const defaultIndex = getFixedFloating(values);
  const indexes = values && values.ancillary ? rateTypeId === LOAN_RATE_TYPES.FIXED ? values.ancillary.fixedIndexes : values.ancillary.floatingIndexes : [];

  const deal = values.details ? values.details.deal : null;
  let loanTypes = values && values.ancillary && values.ancillary.loanTypes ? values.ancillary.loanTypes : [];
  const isAddingSupplemental = deal && deal.dealStatus && deal.dealStatus.id === DEAL_STATUSES.ADDING_SUPPLEMENTAL;
  if (loanTypes && loanTypes.length > 0 && isAddingSupplemental) {
    loanTypes = loanTypes.filter(x => x.id === 6 || x.id === 7);
  }

  return (
    <Grid container>
      <StyledHeaderContainer item xs={12}><StyledHeader>Financials</StyledHeader></StyledHeaderContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="loanTypeId"
          name="details.loanTypeId"
          label="Loan Type *"
          options={loanTypes}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={value => {}}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputNumber
          name={"details.loanTermMonths"}
          label={"Term (months) *"}
          variant={"filled"}
        />
      </StyledGridContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputMoney
          name={"details.amount"}
          label={"Amount ($)"}
          variant={"filled"}
        />
      </StyledGridContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputMoney
          name={"details.initialProceeds"}
          label={"Initial Funding ($)"}
          variant={"filled"}
        />
      </StyledGridContainer>

      <StyledGridContainer container item xs={12}>
        <Grid item xs={5}>
          <StyledFormikInputPercent
            name={"covenants.ltvStabilized"}
            label={"LTV (%)"}
            decimals={3}
            variant={"filled"}
          />
        </Grid>
        <Grid item xs={2} />
        <Grid item xs={5}>
          <StyledFormikInputPercent
            name={"covenants.ltc"}
            label={"LTC (%)"}
            decimals={3}
            variant={"filled"}
          />
        </Grid>
      </StyledGridContainer>

      <Divider />

      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="rateTypeId"
          name="details.rateTypeId"
          label="Rate Type"
          options={[
            { name: "Fixed", id: "53669856-4681-11e9-82f6-0242ac120002" },
            { name: "Floating", id: "5813c493-4681-11e9-82f6-0242ac120002" }
          ]}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={value => {}}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>

      <Divider />

      <StyledGridContainer item xs={12}>
        <StyledFormikInputTypeAhead
          id="indexId"
          name="details.indexId"
          label="Index"
          options={indexes}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={value => {}}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>

      { shouldShowInterestRate(defaultIndex, values) && <StyledGridContainer container item xs={12}>
        <StyledFormikInputPercent
          name={"details.interestRate"}
          label={"Rate (%)"}
          decimals={3}
          variant={"filled"}
        />
                                                        </StyledGridContainer>}

      { shouldShowLoanSpread(values) && <StyledGridContainer container item xs={12}>
        <StyledFormikInputPercent
          name={"details.loanSpread"}
          label={"Spread (%)"}
          decimals={3}
          variant={"filled"}
        />
                                        </StyledGridContainer>}

      <StyledGridContainer item xs={12}>
        <StyledFormikInputPercent
          name={"details.indexFloor"}
          label={"Interest Rate Index Floor (%)"}
          decimals={3}
          variant={"filled"}
        />
      </StyledGridContainer>

      <StyledGridContainer container item xs={12}>
        <StyledFormikInputText
          name={"closingCosts.rateLockFeeAmount"}
          label={"Rate Lock (%)"}
          variant={"filled"}
        />
      </StyledGridContainer>
      <Divider />
    </Grid>
  );
};

export default compose(connect)(FinancialsSection);
